<template>
  <div
  v-bind:style="{
    'font-size': widthInCustomMetric ? widthInCustomMetric : width + 'px',
    'color': color
  }"
  class="comp-app-icon">
    <template v-if="icon === 'monitoring'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,50%,1)" />
        <rect width="47.5" height="50" rx="2" ry="2" x="10" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="47.5" height="50" rx="2" ry="2" x="62.5" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="120" height="20" rx="0" ry="0" x="0" y="70" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="40" height="90" rx="0" ry="0" x="120" y="0" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'dealer'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,50%,1)" />
        <rect width="40" height="90" rx="0" ry="0" x="0" y="0" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="40" height="30" rx="2" ry="2" x="50" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="55" height="30" rx="2" ry="2" x="95" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="20" rx="2" ry="2" x="50" y="45" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="70" style="fill:hsla(202,0%,100%,0.5)" />
      </svg>
    </template>
    <template v-else-if="icon === 'dealerMobile'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,10%,1)" />
        <rect width="50" height="90" rx="2" ry="2" x="55" y="0" style="fill:hsla(202,0%,100%,1)" />
        <rect width="10" height="2" rx="1" ry="1" x="75" y="3" style="fill:hsla(202,0%,70%,1)" />
        <rect width="7.5" height="7.5" rx="7.5" ry="7.5" x="76.25" y="80" style="fill:hsla(202,0%,70%,1)" />
        <rect width="50" height="70" rx="0" ry="0" x="55" y="7.5" style="fill:hsla(202,50%,50%,1)" />
        <rect width="50" height="22.5" rx="0" ry="0" x="55" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="45" height="10" rx="1" ry="1" x="57.5" y="35" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="45" height="10" rx="1" ry="1" x="57.5" y="47.5" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="45" height="7.5" rx="1" ry="1" x="57.5" y="60" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="45" height="5" rx="1" ry="1" x="57.5" y="70" style="fill:hsla(202,0%,100%,0.5)" />
      </svg>
    </template>
    <template v-else-if="icon === 'enduser'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,50%,1)" />
        <rect width="40" height="90" rx="0" ry="0" x="0" y="0" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="60" rx="2" ry="2" x="50" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="20" height="5" rx="1" ry="1" x="79" y="75" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="20" height="5" rx="1" ry="1" x="101" y="75" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'enduserMobile'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,10%,1)" />
        <rect width="50" height="90" rx="2" ry="2" x="55" y="0" style="fill:hsla(202,0%,100%,1)" />
        <rect width="10" height="2" rx="1" ry="1" x="75" y="3" style="fill:hsla(202,0%,70%,1)" />
        <rect width="7.5" height="7.5" rx="7.5" ry="7.5" x="76.25" y="80" style="fill:hsla(202,0%,70%,1)" />
        <rect width="50" height="70" rx="0" ry="0" x="55" y="7.5" style="fill:hsla(202,50%,50%,1)" />
        <rect width="45" height="20" rx="1" ry="1" x="57.5" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="45" height="20" rx="1" ry="1" x="57.5" y="32.5" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="45" height="20" rx="1" ry="1" x="57.5" y="55" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'operation'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,50%,1)" />
        <rect width="40" height="90" rx="0" ry="0" x="0" y="0" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="25" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="40" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="55" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="70" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'operation-v2'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,0%,10%,1)" />
        <rect width="40" height="90" rx="0" ry="0" x="0" y="0" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="25" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="40" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="55" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="70" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'aws-console'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(50,100%,40%,1)" />
        <rect width="40" height="90" rx="0" ry="0" x="0" y="0" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="25" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="40" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="55" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="50" y="70" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'status'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,50%,1)" />
        <rect width="100" height="25" rx="2" ry="2" x="30" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="30" y="40" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="100" height="10" rx="2" ry="2" x="30" y="55" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="100" height="10" rx="2" ry="2" x="30" y="70" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
    <template v-else-if="icon === 'share'">
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,10%,1)" />
        <rect width="50" height="90" rx="2" ry="2" x="55" y="0" style="fill:hsla(202,0%,100%,1)" />
        <rect width="10" height="2" rx="1" ry="1" x="75" y="3" style="fill:hsla(202,0%,70%,1)" />
        <rect width="7.5" height="7.5" rx="7.5" ry="7.5" x="76.25" y="80" style="fill:hsla(202,0%,70%,1)" />
        <rect width="50" height="70" rx="0" ry="0" x="55" y="7.5" style="fill:hsla(202,0%,0%,1)" />
        <rect width="50" height="30" rx="0" ry="0" x="55" y="7.5" style="fill:hsla(202,0%,100%,0.4)" />
        <rect width="15" height="5" rx="0" ry="0" x="65" y="42" style="fill:hsla(202,0%,100%,0.4)" />
        <rect width="15" height="5" rx="0" ry="0" x="80" y="42" style="fill:hsla(202,0%,100%,0.9)" />
        <rect width="17" height="12" rx="0" ry="0" x="61" y="56" style="fill:hsla(0,100%,70%,0.9)" />
        <rect width="17" height="12" rx="0" ry="0" x="82" y="56" style="fill:hsla(202,100%,100%,0.9)" />
      </svg>
    </template>
    <template v-else>
      <svg width="240" height="135" viewBox="0 0 160 90" xmlns="http://www.w3.org/2000/svg">
        <rect width="160" height="90" rx="0" ry="0" style="fill:hsla(202,50%,50%,1)" />
        <rect width="47.5" height="50" rx="2" ry="2" x="10" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="47.5" height="50" rx="2" ry="2" x="62.5" y="10" style="fill:hsla(202,0%,100%,0.8)" />
        <rect width="120" height="20" rx="0" ry="0" x="0" y="70" style="fill:hsla(202,0%,100%,0.5)" />
        <rect width="40" height="90" rx="0" ry="0" x="120" y="0" style="fill:hsla(202,0%,100%,0.8)" />
      </svg>
    </template>
  </div>
</template>

<script>
export default {
  name: 'comp-app-icon',
  props: {
    icon: {
      type: String,
      default: function () {
        return null
      }
    },
    width: {
      type: Number,
      default: function () {
        return 40
      }
    },
    widthInCustomMetric: {
      type: String,
      default: function () {
        return null
      }
    },
    color: {
      type: String,
      default: function () {
        return null
      }
    }
  }
}
</script>

<style scoped>
.comp-app-icon {
  /* size */
  height: calc(1em / 16 * 9);
  /* position */
  position: relative;
}

.comp-app-icon svg{
  /* common */
  fill: currentColor;
  /* size */
  max-width: 100%;
  width: 1em;
  height: calc(1em / 16 * 9);
  /* position */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/CompAppIcon.vue